export default {
  ClientMetadataAdapter: Symbol('ClientMetadataAdapter'),
  ExternalAuthProvider: Symbol('ExternalAuthProvider'),
};
